// Journey block tabs (templates/_blocks/_contentMatrix/_journeyBlock.twig): ARIA tab pattern. Click or arrow keys
// (Home/End too) switch stages; only the selected tab is in the tab order.
// On mobile, a sticky header shows the current step + "(1 of N)" counter and toggles a step-picker dropdown;
// bottom-of-panel buttons ([data-journey-goto]) advance or step back and scroll the top of the panel into view.
(function() {
    function setup(journey) {
        var tabs = Array.prototype.slice.call(journey.querySelectorAll('[role="tab"]'));
        var panels = tabs.map(function(tab) { return document.getElementById(tab.getAttribute('aria-controls')); });
        var nav = journey.querySelector('[data-journey-nav]');
        var toggle = journey.querySelector('[data-journey-toggle]');
        var currentNum = journey.querySelector('[data-journey-current-num]');
        var currentCount = journey.querySelector('[data-journey-current-count]');
        var currentTitle = journey.querySelector('[data-journey-current-title]');
        var progress = journey.querySelector('[data-journey-progress]');
        var total = tabs.length;

        function closeMenu() {
            if ( !nav || !toggle ) {
                return;
            }
            nav.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
        }

        function scrollIntoViewIfNeeded(force) {
            var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 72;
            var rect = journey.getBoundingClientRect();
            if ( force || rect.top < headerHeight ) {
                var top = window.pageYOffset + rect.top - headerHeight - 12;
                var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
            }
        }

        function select(index, focus, shouldScroll) {
            tabs.forEach(function(tab, i) {
                var active = i === index;
                tab.setAttribute('aria-selected', active ? 'true' : 'false');
                tab.tabIndex = active ? 0 : -1;
                if ( panels[i] ) {
                    panels[i].hidden = !active;
                }
            });
            if ( currentNum ) {
                currentNum.textContent = String(index + 1);
            }
            if ( currentCount ) {
                currentCount.textContent = '(' + (index + 1) + ' of ' + total + ')';
            }
            if ( currentTitle ) {
                var label = tabs[index].getAttribute('data-step-title') || tabs[index].textContent.trim();
                currentTitle.textContent = label;
            }
            if ( progress && total > 0 ) {
                progress.style.width = (((index + 1) / total) * 100).toFixed(2) + '%';
            }
            closeMenu();
            if ( shouldScroll ) {
                scrollIntoViewIfNeeded(false);
            }
            if ( focus ) {
                tabs[index].focus();
            }
        }

        if ( toggle && nav ) {
            toggle.addEventListener('click', function() {
                var open = nav.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            });

            document.addEventListener('click', function(event) {
                if ( nav.classList.contains('is-open') && !nav.contains(event.target) ) {
                    closeMenu();
                }
            });

            journey.addEventListener('keydown', function(event) {
                if ( event.key === 'Escape' && nav.classList.contains('is-open') ) {
                    closeMenu();
                    toggle.focus();
                }
            });
        }

        tabs.forEach(function(tab, i) {
            tab.addEventListener('click', function() { select(i, false, true); });
            tab.addEventListener('keydown', function(event) {
                var next = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: tabs.length - 1 }[event.key];
                if ( next === undefined ) {
                    return;
                }
                event.preventDefault();
                select((next + tabs.length) % tabs.length, true, false);
            });
        });

        journey.querySelectorAll('[data-journey-goto]').forEach(function(btn) {
            btn.addEventListener('click', function() {
                var target = parseInt(btn.getAttribute('data-journey-goto'), 10);
                if ( !isNaN(target) && target >= 0 && target < total ) {
                    select(target, false, true);
                }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('[data-journey]').forEach(setup);
    });
})();
